export const CREDIT_BLOCK_SYSTEM_CASE_ORIGIN = 'System';

const SYSTEM_ORIGIN_ALIASES = new Set([
  'credit block operations',
  'regal credit block operations',
  'credit_block_operations',
]);

export function normalizeCreditBlockCaseOrigin(value: unknown): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  return SYSTEM_ORIGIN_ALIASES.has(raw.toLowerCase()) ? CREDIT_BLOCK_SYSTEM_CASE_ORIGIN : raw;
}
